import { render } from "./roba-loader.vue?vue&type=template&id=311e508d&scoped=true&ts=true"
import script from "./roba-loader.vue?vue&type=script&lang=ts"
export * from "./roba-loader.vue?vue&type=script&lang=ts"

import "./roba-loader.vue?vue&type=style&index=0&id=311e508d&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-311e508d"]])

export default __exports__